function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpgradeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20.538,
    xmlns: "http://www.w3.org/2000/svg",
    height: 16,
    id: "screenshot-8956a6ae-c5ec-80a3-8007-843d364daa1b",
    viewBox: "-721 2465 20.538 16",
    style: {
      WebkitPrintColorAdjust: ":exact"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "shape-8956a6ae-c5ec-80a3-8007-843d364daa1b",
    style: {
      fill: "#000000"
    },
    rx: 0,
    ry: 0
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("svg", _extends({
    id: "render-53396-Layer_2",
    viewBox: "0 0 32.07 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "render-53396-Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28,18.81H4.29C2.73,12.77,0,4.1,0,4.03l.2.35c.08.08,5.86,7.25,9.15,6.57,2.33-.48,4.59-3.26,6.64-10.32l.12-.63.16.63c2.05,7.06,4.36,9.84,6.69,10.32,3.29.68,8.66-6.06,8.82-6.3l.31-.47s-2.51,8.59-4.07,14.63Z",
    style: {
      fill: "#dca600",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.29,23.79c0,.67.54,1.21,1.21,1.21h21.28c.67,0,1.21-.54,1.21-1.21v-3.34H4.29v3.34Z",
    style: {
      fill: "#dca600",
      strokeWidth: 0
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "render-53396-Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28,18.81H4.29C2.73,12.77,0,4.1,0,4.03l.2.35c.08.08,5.86,7.25,9.15,6.57,2.33-.48,4.59-3.26,6.64-10.32l.12-.63.16.63c2.05,7.06,4.36,9.84,6.69,10.32,3.29.68,8.66-6.06,8.82-6.3l.31-.47s-2.51,8.59-4.07,14.63Z",
    style: {
      fill: "#dca600",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.29,23.79c0,.67.54,1.21,1.21,1.21h21.28c.67,0,1.21-.54,1.21-1.21v-3.34H4.29v3.34Z",
    style: {
      fill: "#dca600",
      strokeWidth: 0
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-8956a6ae-c5ec-80a3-8007-843d36509a3c",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-8956a6ae-c5ec-80a3-8007-843d36509a3c"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: -721,
    y: 2465,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    width: 20.524799999999914,
    height: 16,
    fill: "none",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-8956a6ae-c5ec-80a3-8007-843d36509a3d"
  }, /*#__PURE__*/React.createElement("defs", {
    style: {
      fill: "#000000"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "shape-8956a6ae-c5ec-80a3-8007-843d36509a3e",
    style: {
      fill: "#000000"
    },
    rx: 0,
    ry: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-8956a6ae-c5ec-80a3-8007-843d365152f1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-8956a6ae-c5ec-80a3-8007-843d365152f1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-703.0799560546875,2477.038330078125L-718.25439453125,2477.038330078125C-719.2528076171875,2473.1728515625,-721,2467.6240234375,-721,2467.5791015625L-720.8719482421875,2467.80322265625C-720.82080078125,2467.8544921875,-717.12158203125,2472.443115234375,-715.0159912109375,2472.008056640625C-713.5247802734375,2471.70068359375,-712.078369140625,2469.92138671875,-710.766357421875,2465.4033203125L-710.6896362304688,2465L-710.587158203125,2465.4033203125C-709.275146484375,2469.92138671875,-707.7967529296875,2471.70068359375,-706.3055419921875,2472.008056640625C-704.199951171875,2472.443115234375,-700.76318359375,2468.129638671875,-700.6608276367188,2467.975830078125L-700.46240234375,2467.675048828125C-700.46240234375,2467.675048828125,-702.0687866210938,2473.1728515625,-703.067138671875,2477.038330078125Z",
    style: {
      strokeWidth: 0,
      fill: "#f7ba00",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-8956a6ae-c5ec-80a3-8007-843d3651904b"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-8956a6ae-c5ec-80a3-8007-843d3651904b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-718.25439453125,2480.2255859375C-718.25439453125,2480.654296875,-717.9088134765625,2481,-717.47998046875,2481L-703.8607788085938,2481C-703.4319458007812,2481,-703.08642578125,2480.654296875,-703.08642578125,2480.2255859375L-703.08642578125,2478.087890625L-718.25439453125,2478.087890625L-718.25439453125,2480.2255859375Z",
    style: {
      strokeWidth: 0,
      fill: "#f7ba00",
      fillOpacity: 1
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgradeIcon);
export default __webpack_public_path__ + "static/media/upgradeIcon.1bccbdbad4161d35dd12c3978ce234db.svg";
export { ForwardRef as ReactComponent };